import {createContext, useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'

export default function ContextAuthentication() {
  return <div>Must use context & provider named exports</div>
}

const defaultContextValue = {user: null}

export const AuthenticationContext = createContext(defaultContextValue)

export const AuthenticationProvider = ({children}) => {
  const {domain, user} = useContext(Context)
  const [currentUser, setCurrentUser] = useState(user)

  const renewCurrentUser = async () => {
    // TODO: we should renew the user only if useCase result is successful
    const user = await domain.get('get_current_user_use_case').execute()

    setCurrentUser(user)
  }

  useMount(() => {
    const {unsubscribe: unsubscribeLoginAuthenticationUseCase} = domain
      .get('login_authentication_use_case')
      .subscribe(() => renewCurrentUser())

    const {unsubscribe: unsubscribeUpdateDataUserUseCase} = domain
      .get('update_data_user_use_case')
      .subscribe(() => renewCurrentUser())

    const {unsubscribe: unsubscribeUpdateUserUseCase} = domain
      .get('publish_ad_publisher_use_case')
      .subscribe(() => renewCurrentUser())

    return () => {
      unsubscribeLoginAuthenticationUseCase()
      unsubscribeUpdateDataUserUseCase()
      unsubscribeUpdateUserUseCase()
    }
  })

  const isLogged = Boolean(currentUser && currentUser.userId)

  return (
    <AuthenticationContext.Provider value={{user: currentUser, isLogged}}>{children}</AuthenticationContext.Provider>
  )
}

AuthenticationProvider.propTypes = {
  children: PropTypes.any
}

ContextAuthentication.displayName = 'ContextAuthentication'
ContextAuthentication.propTypes = {}
